import './community.css'

export default function Community() {
    return (
        <div><h1>Community</h1></div>
    )
}
